var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "feature-value pt-0 pb-0"
  }, [typeof _vm.value === 'boolean' ? [_vm.value ? _c('v-icon', {
    staticClass: "included-icon",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-check")]) : _c('span', {
    staticClass: "excluded-mark",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("—")]), _c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v(_vm._s(_vm.value ? _vm.includedLabel : _vm.notIncludedLabel))])] : [_vm._v(_vm._s(_vm.value))]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }